
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="currentColor">
	<path
		d="M15 26.25C8.78719 26.25 3.75 21.2128 3.75 15C3.75 8.78719 8.78719 3.75 15 3.75C21.2128 3.75 26.25 8.78719 26.25 15C26.25 21.2128 21.2128 26.25 15 26.25ZM15 1.875C7.7625 1.875 1.875 7.7625 1.875 15C1.875 22.2375 7.7625 28.125 15 28.125C22.2375 28.125 28.125 22.2375 28.125 15C28.125 7.7625 22.2375 1.875 15 1.875Z"
		fill="currentColor" />
	<path
		d="M12.6563 18.1282L9.10031 14.5723L7.77469 15.8979L12.6563 20.7795L22.2253 11.2104L20.8997 9.88477L12.6563 18.1282Z"
		fill="currentColor" />
</svg>
    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'CheckCircleLight',
    }) as DefineComponent
    </script>
    